export class Model {
  constructor(
    fields = {
      id: null
    }
  ) {
    Object.keys(fields).forEach(key => {
      this[key] = fields[key];
    });
  }

  /**
   *
   * @returns {any}
   */
  toNet() {
    return JSON.parse(JSON.stringify(this.fields));
  }
}
